import Appsignal from '@appsignal/javascript'

const config = window.RUNTIME_CONFIG

export const appsignal = new Appsignal({
  key: config?.APPSIGNAL_ENABLED ? config.APPSIGNAL_FRONTEND_KEY : undefined,
  revision: config?.APPSIGNAL_REVISION,
})
